import axiosInstance from '../../../config/axiosInstance';
import type {
  ProductionDataQualitySummaryResponse,
  ProductionIntelligenceAuditResponse,
} from '../types/productionIntelligence';

export async function getProductionIntelligenceMaterialTraceability(params: {
  reference_date: string;
  production_line_config_id?: string;
  limit?: number;
  order_search?: string;
}): Promise<ProductionIntelligenceAuditResponse> {
  const { data } = await axiosInstance.get<ProductionIntelligenceAuditResponse>(
    '/industrial-costs/production-intelligence/material-traceability',
    { params },
  );
  return data;
}

export async function getProductionDataQualitySummary(params: {
  reference_date: string;
}): Promise<ProductionDataQualitySummaryResponse> {
  const { data } = await axiosInstance.get<ProductionDataQualitySummaryResponse>(
    '/industrial-costs/production-intelligence/data-quality-summary',
    { params },
  );

  return data;
}
